import { FormElement } from "@progress/kendo-react-form";
import { SchedulerForm } from "@progress/kendo-react-scheduler";
import * as React from "react";
import { CustomDialog } from "./custom-dialog";
import { CustomFormEditor } from "./custom-form-editor";
import { payRateTypeObj } from "../../../helpers/data";
import { useSelector } from "react-redux";
export const FormWithCustomEditor = (props) => {
  const payRateType = useSelector(store => store.jobOpportunity.payRateType)
  const requiredValidator = React.useCallback(
    (value) =>
      value === undefined || value === null || value === ""
        ? "Field is required."
        : undefined,
    []
  );
  const arrayLengthValidator = React.useCallback(
    (value) => (value && value.length ? "" : "Field is required."),
    []
  );
  const formValidator = (_dataItem, formValueGetter) => {
    let result = {};
    if(payRateType === payRateTypeObj.manualCal){
      result.payRateOccurrenceAmount = [
        requiredValidator(formValueGetter("payRateOccurrenceAmount")),
      ]
        .filter(Boolean)
        .reduce((current, acc) => current || acc, "");
    }
    // result.Treatment = [requiredValidator(formValueGetter('Treatment'))]
    //   .filter(Boolean)
    //   .reduce((current, acc) => current || acc, '');
    result.jobsApproversList = [
      arrayLengthValidator(formValueGetter("jobsApproversList")),
    ]
      .filter(Boolean)
      .reduce((current, acc) => current || acc, "");
    result.jobsContactsList = [
      arrayLengthValidator(formValueGetter("jobsContactsList")),
    ]
      .filter(Boolean)
      .reduce((current, acc) => current || acc, "");
    // result.billingRate = [requiredValidator(formValueGetter('billingrate'))]
    // .filter(Boolean)
    // .reduce((current, acc) => current || acc, '');
    return result;
  };

  return (
    <SchedulerForm
      {...props}
      editor={CustomFormEditor}
      // dialog={CustomDialog}
      validator={formValidator}
    />
  );
};
